export default "May 3, 2020";